import { OopsCategory } from "src/app/core/components/categories";

export const PathUrl = '/main/settings/'

export const FormOfPaymentType = 'Form of Payment Type'
export const FormOfPayment = 'Form of Payment'
export const FormOfPaymentIssuer = 'Form of Payment Issuer'
export const PaymentAcquirer = 'Payment Acquirer'
export const PaymentMerchant = 'Payment Merchant'

export const PaymentDefinitions: OopsCategory[] = [
    {
        name: FormOfPaymentType,
        url: `${PathUrl}`,
        modifiedBy: null,
        modifiedDateTime: null,
        productCount: null
    },
    {
        name: FormOfPaymentIssuer,
        url: `${PathUrl}`,
        modifiedBy: null,
        modifiedDateTime: null,
        productCount: null
    },
    {
        name: PaymentAcquirer,
        url: `${PathUrl}`,
        modifiedBy: null,
        modifiedDateTime: null,
        productCount: null
    },
]

export const FormOfPaymentTypeSecurityCode = 'FORMOFPAYMENTTYPE'
export const FormOfPaymentIssuerSecurityCode = 'FORMOFPAYMENTISSUER'
export const PaymentAcquirerSecurityCode = 'PAYMENTACQUIRER'

export const PaymentDefinitionSecurityCodes: Map<string, string> = new Map<string, string>()
    .set(FormOfPaymentType, FormOfPaymentTypeSecurityCode)
    .set(FormOfPaymentIssuer, FormOfPaymentIssuerSecurityCode)
    .set(PaymentAcquirer, PaymentAcquirerSecurityCode)
